<template>
    <div ref="map" class="h-100">
        <iframe
            class="w-100 h-100"
            loading="lazy"
            allowfullscreen
            style="border: 0"
            :src="url">
        </iframe>
    </div>
</template>
<script lang="ts">
import {GOOGLE_MAPS_API_KEY} from '@/shared/configuration';
import {computed, defineComponent} from 'vue';

export default defineComponent({
    props: {
        longitude: {
            type: Number,
            required: true,
        },
        latitude: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const url = computed(() => {
            const params = new URLSearchParams({
                location: `${props.latitude},${props.longitude}`,
                key: GOOGLE_MAPS_API_KEY,
                source: 'outdoor',
            });
            return `https://www.google.com/maps/embed/v1/streetview?${params.toString()}`;
        });

        return {url};
    },
});
</script>
